import { IPeriodResults } from '@interfaces/IPeriodResults';
import {
  EStudentsPerformanceActions,
  StudentsPerformanceActions,
} from '@myStore/students-performance/students-perfomance.actions';
import {
  initialsStudentPerformanceState,
  IStudentPerformanceState,
} from '@myStore/students-performance/students-performance.state';

export const studentsPerformanceReducers = (
  state = initialsStudentPerformanceState,
  actions: StudentsPerformanceActions
): IStudentPerformanceState => {
  switch (actions.type) {
    case EStudentsPerformanceActions.GetStudentsPerformancePeriodRequest:
      return {
        ...state,
        isLoading: true,
      };
    case EStudentsPerformanceActions.GetStudentsPerformancePeriodSuccess:
      return {
        ...state,
        studentPerformance: actions.studentsPerformance,
        isLoading: false,
      };
    case EStudentsPerformanceActions.GetStudentsPerformancePeriodFailure:
      return {
        ...state,
        isLoading: false,
        errors: actions.error,
      };
    case EStudentsPerformanceActions.ClearStudentsPerformancePeriod:
      return {
        ...state,
        studentPerformance: null,
        errors: null,
      };

    case EStudentsPerformanceActions.SetProbationary:
      return {
        ...state,
        studentPerformance: setProbationaryForStudent(
          state.studentPerformance,
          actions.studentId,
          actions.isProbation
        ),
      };

    default:
      return state;
  }
};

const setProbationaryForStudent = (
  period: IPeriodResults | null,
  studentId: number,
  isProbation: boolean
): IPeriodResults | null => {
  if (period && !period.is_esdp) {
    return {
      ...period,
      students: period.students.map(student => {
        if (studentId === student.id) {
          return {
            ...student,
            is_probation: isProbation,
          };
        }

        return student;
      }),
    };
  }

  if (period && period.results) {
    return {
      ...period,
      results: period.results.map(student => {
        if (studentId === student.id) {
          return {
            ...student,
            is_probation: isProbation,
          };
        }

        return student;
      }),
    };
  }

  return period;
};
